import TitleWithCaption from './TitleWithCaption'

export default TitleWithCaption
